// src/Projects.js
import React, { useState } from "react";
import { Card, Typography, Row, Col, Button, Modal, Image } from "antd";
import {
  ArrowRightOutlined,
  CloseOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { SERVICES_DATA } from "../constants";
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;

const ServiceCard = ({ title, subtitle, description, image, url }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const handleImageLoaded = () => {
    setLoading(false);
  };
  const openUrl = () => {
    window.open(url, "_blank");
  };
  return (
    <Col
      xs={24}
      sm={12}
      md={8}
      lg={6}
      xl={6}
      xxl={4}
      style={{ marginBottom: "16px" }}
    >
      <Card
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
        }}
        cover={
          <img
            alt={title}
            src={image}
            style={{ objectFit: "cover", height: "180px" }}
          />
        }
      >
        <div style={{ color: "grey" }}>{subtitle}</div>
        <Title level={4}>{title}</Title>
        <Paragraph ellipsis={{ rows: 2, expandable: false }}>
          {description}
        </Paragraph>
        <Row>
          <Col span={12}>
            <Button
              type="ghost"
              style={{ borderRadius: "8px", width: "100%" }}
              onClick={showModal}
            >
              Details
            </Button>
          </Col>
          <Col span={1} />
          <Col span={11}>
            <Button
              type="primary"
              style={{ borderRadius: "8px", width: "100%" }}
              onClick={openUrl}
            >
              Order
            </Button>
          </Col>
        </Row>

        <Modal
          title={null}
          visible={visible}
          onCancel={handleCancel}
          footer={null}
          centered
          bodyStyle={{ padding: 0 }}
        >
          <Image
            alt={title}
            src={image}
            style={{ width: "100%", objectFit: "cover" }}
            onLoad={handleImageLoaded}
            loading={loading}
            preview={false}
          />
          <div style={{ padding: "20px" }}>
            <Title level={3}>{title}</Title>
            <Title level={5}>{subtitle}</Title>
            <Paragraph>{description}</Paragraph>
            <Row>
              <Col span={12}>
                <Button
                  size="large"
                  icon={<CloseOutlined />}
                  type="ghost"
                  style={{ borderRadius: "8px", width: "100%" }}
                  onClick={handleCancel}
                >
                  Close
                </Button>
              </Col>
              <Col span={1} />
              <Col span={11}>
                <Button
                  size="large"
                  icon={<ShoppingCartOutlined />}
                  type="primary"
                  style={{ borderRadius: "8px", width: "100%" }}
                  onClick={openUrl}
                >
                  Order
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
      </Card>
    </Col>
  );
};

const Services = () => {
  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >
        <Col>
          <Title level={3}>Services</Title>
        </Col>
        <Col>
          <Link to="/services">
            <a
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
              onClick={null}
            >
              <span style={{ marginRight: "8px" }}>View All</span>
              <ArrowRightOutlined />
            </a>
          </Link>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {SERVICES_DATA.map((entry, index) => (
          <ServiceCard
            key={index}
            title={entry.title}
            subtitle={entry.subtitle}
            description={entry.description}
            image={entry.image}
            url={entry.url}
          />
        ))}
      </Row>
    </div>
  );
};

export default Services;
